// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__PRWjr","text":"Article_text__11gYh","title":"Article_title___DQlK","media":"Article_media__RzNVH","image":"Article_image__LTVfX"};